import React from "react";
import { Mail } from "lucide-react";
import { CONTACT_EMAIL } from "@/data/content";

// Floating direct-contact button (bottom-right) — opens the visitor's mail app.
const FloatingContact = () => {
  return (
    <a
      href={`mailto:${CONTACT_EMAIL}`}
      data-testid="floating-contact-btn"
      aria-label="Email by VAYA"
      className="group fixed bottom-6 right-6 md:bottom-8 md:right-8 z-[90] flex items-center gap-3 bg-olive text-cream hover:bg-charcoal transition-all duration-300 shadow-lg shadow-charcoal/10 pl-4 pr-4 md:pr-5 py-4 rounded-full"
    >
      <Mail size={20} strokeWidth={1.5} />
      <span className="max-w-0 overflow-hidden whitespace-nowrap text-xs uppercase tracking-[0.18em] opacity-0 transition-all duration-300 group-hover:max-w-[180px] group-hover:opacity-100">
        Get in touch
      </span>
    </a>
  );
};

export default FloatingContact;
